// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__uSs_9","emails":"CreateEditClinics_emails__1X1gt","emailTagLabel":"CreateEditClinics_emailTagLabel__1-uov"};